import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { nextTick, watch, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useProductStore } from '@/store/product';
export default {
  __name: 'secondMenu',
  props: ['menus', 'level', 'bread_id'],
  setup(__props) {
    // import menuModule from "@/components/public_/menu_module.vue";
    var product_store = useProductStore();
    var router = useRouter();
    var props = __props;
    watch(() => {
      return props.bread_id;
    }, () => {
      setTimeout(() => {
        var _document$getElementB;
        var scoll_top = (_document$getElementB = document.getElementById('is_selected2')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.offsetTop;
        product_store.scoll_top = scoll_top;
      }, 300);
    });
    return (_ctx, _cache) => {
      var _component_second_menu = _resolveComponent("second-menu", true);
      var _component_el_sub_menu = _resolveComponent("el-sub-menu");
      var _component_el_menu_item = _resolveComponent("el-menu-item");
      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menus, item => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.id
        }, [item.children && item.children.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
          key: 0,
          index: item.id + '',
          id: [__props.bread_id == item.id ? 'is_selected2' : '']
        }, {
          title: _withCtx(() => [_createElementVNode("span", {
            class: _normalizeClass(['title', 'level_' + __props.level, __props.bread_id == item.id ? 'is_selected' : ''])
          }, _toDisplayString(item.name), 3)]),
          default: _withCtx(() => [_createVNode(_component_second_menu, {
            menus: item.children,
            level: __props.level + 1,
            bread_id: __props.bread_id
          }, null, 8, ["menus", "level", "bread_id"])]),
          _: 2
        }, 1032, ["index", "id"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 1,
          index: item.id + '',
          id: [__props.bread_id == item.id ? 'is_selected1' : '']
        }, {
          title: _withCtx(() => [_createElementVNode("span", {
            class: _normalizeClass(['title', 'level_' + __props.level, __props.bread_id == item.id ? 'is_selected' : ''])
          }, _toDisplayString(item.name), 3)]),
          _: 2
        }, 1032, ["index", "id"]))], 64);
      }), 128);
    };
  }
};